import React from "react";
import { Helmet } from "react-helmet";
import ResourcesCommonComponent from "./ResourcesCommonComponent";
import { resourcesServices } from "../../services/resourcesService";
import { defer } from "react-router-dom";
const WigMakerSupplier = () => {
  return (
    <div>
      <Helmet>
        <title>Wig Makers Or Suppliers - Cope With Cancer</title>

        <meta
          name="description"
          content="In cancer patients chemotherapy targets all the rapidly dividing cells resulting in hair loss. Cope with cancer has listed some of the wig makers/suppliers."
        />
        <meta name="robots" content="noodp" />
        <link
          rel="canonical"
          href="https://www.copewithcancer.org/wig-makers-suppliers"
        />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Wig Makers Or Suppliers - Cope With Cancer"
        />
        <meta
          property="og:description"
          content="In cancer patients chemotherapy targets all the rapidly dividing cells resulting in hair loss. Cope with cancer has listed some of the wig makers/suppliers."
        />
        <meta
          property="og:url"
          content="https://www.copewithcancer.org/wig-makers-suppliers"
        />
        <meta property="og:site_name" content="Cope with Cancer" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/copewithcancer/"
        />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:description"
          content="In cancer patients chemotherapy targets all the rapidly dividing cells resulting in hair loss. Cope with cancer has listed some of the wig makers/suppliers."
        />
        <meta
          name="twitter:title"
          content="Wig Makers Or Suppliers - Cope With Cancer"
        />
        <meta name="twitter:site" content="@copewithcancer" />
        <meta name="twitter:creator" content="@copewithcancer" />
        <meta property="DC.date.issued" content="2016-06-07T10:15:46+00:00" />
      </Helmet>

      <div className="topspace">
        <div className="text-center">
          <div className="wigmakerssuppliers"><div className="bannertitleNew bannertitleNew">Wig Makers / Suppliers</div></div>
          {/* <img src="https://cwc-react.s3.ap-south-1.amazonaws.com/img/ResourcesImages/wig_makers_suppliers_banner-2-300x57.jpg" alt="" className="w-100"></img> */}
          <h1 className="bannertitle displayNone">Wig Makers / Suppliers</h1>
        </div>
        <div className="contentBox">
          <div className="container">
            <h3 className="Bold28 mb20">Wig Makers / Suppliers</h3>
            <ResourcesCommonComponent senderComponent="Accomodation" />
          </div>
        </div>
      </div>

      {/* <div className="container"><br /><br /><br /><br /><br /><br />
                <img class="d-block w-100" src={WigImg} /><br /><br />
                <h1>Wig Makers / Suppliers</h1>
            </div> */}
    </div>
  );
};
export default WigMakerSupplier;

const getResource = async ({ request, params }) => {
  try {
    const url = new URL(request.url);
    const searchParams = url.search ? url.search : "?pageNumber=1&city=mumbai&state=maharashtra&location";
    console.log(searchParams);
    const resource = "wigMakersSuppliers";
    const responce = await new Promise((resolve, reject) => {
      resourcesServices.getResources(
        resource,
        searchParams,
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
    return {
      resources: responce.data.ResponseObject,
      totalRecords: responce.data.TotalRecords,
    };
  } catch (err) {
    console.log(err);
    return null;
  }
};
const getLocation = async ({ request, params }) => {
  try {
    const url = new URL(request.url);
    const searchParams = url.search ? url.search : null;
    console.log(searchParams);
    const resource = "wigMakersSuppliers";
    const responce = await new Promise((resolve, reject) => {
      resourcesServices.getLocations(
        resource,
        searchParams,
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
    return responce.data.ResponseObject;
  } catch (err) {
    console.log(err);
    return null;
  }
};
export const loader = async ({ request, params }) => {
  return defer({
    data: await getResource({ request, params }),
    locations: await getLocation({ request, params })
  });
};
